/* eslint-disable no-case-declarations */

import _ from 'lodash';
import APP from 'desktop/epgTypes';
import { getEpgInstance } from '../utils/coreEPG';

const initialState = {
  subscriptionInfoMap: {},
  channelsMap: {},
  orderedChannels: [],
  channelsByGenres: [],
  currentChannel: null,
  currentChannelAbsoluteId: null, // schema: { id: channel_id, genreId: if_of_current_genre }
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APP.EVENT_CURRENT_CHANNEL_CHANGED:
      return {
        ...state,
        currentChannel: payload.data,
      };

    case APP.EVENT_CHANNELS_READY: {
      const { orderedChannels, channels } = payload;
      let currentChannelAbsoluteId = null;
      let currentChannelId;
      for (let i = 0, l = orderedChannels.length; i < l; ++i) {
        currentChannelId = _.find(orderedChannels[i].channels, (id) => channels[id].isCurrent);
        if (currentChannelId) {
          currentChannelAbsoluteId = {
            id: currentChannelId,
            genreId: orderedChannels[i].id,
          };
          break;
        }
      }

      return {
        ...state,
        channelsMap: channels,
        channelsByGenres: [...orderedChannels],
        currentChannel: channels[currentChannelId],
        currentChannelAbsoluteId,
        orderedChannels,
      };
    }

    case APP.SET_CURRENT_CHANNEL_ABSOLUTE_ID:
      return {
        ...state,
        currentChannelAbsoluteId: payload,
      };

    case APP.EVENT_FAVORITE_TOGGLED: {
      const { state: favState, channel: favChannel } = payload;
      const channelsByGenres = [...state.channelsByGenres];
      const currentChannelAbsoluteId = { ...state.currentChannelAbsoluteId };
      const epgInstance = getEpgInstance();
      let favGenreIndex = _.findIndex(channelsByGenres, { id: epgInstance.FAVORITE_GENRE_ID });
      if (favState) {
        if (favGenreIndex === -1) {
          // check that favorite category is present and add it if not
          channelsByGenres.unshift({
            id: epgInstance.FAVORITE_GENRE_ID,
            title: epgInstance.translate('favoriteChannels', 'Избранные'),
            channels: [],
          });
          favGenreIndex = 0;
        }
        channelsByGenres[favGenreIndex].channels.unshift(favChannel.id);
      } else {
        if (favGenreIndex !== -1) { // eslint-disable-line
          const channelIndex = channelsByGenres[favGenreIndex].channels.indexOf(favChannel.id);
          if (channelIndex !== -1) {
            channelsByGenres[favGenreIndex].channels.splice(channelIndex, 1);
            if (channelsByGenres[favGenreIndex].channels.length === 0) {
              channelsByGenres.splice(favGenreIndex, 1);
            }
          }
        }
      }
      currentChannelAbsoluteId.genreId = favState
        ? epgInstance.FAVORITE_GENRE_ID
        : favChannel.originalGenre.id;
      return {
        ...state,
        channelsByGenres,
        currentChannelAbsoluteId,
      };
    }

    case APP.EVENT_SUBSCRIPTION_INFO_LOADED:
      return {
        ...state,
        subscriptionInfoMap: payload,
      };

    default:
      return state;
  }
};
